import { Form, Checkbox, Space, Tooltip } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';

import APP_CONFIG, { FORM_RULES } from '../../utils/config';

import styles from './Step2.module.scss';

const { lostWorkBook } = APP_CONFIG.step2Options;

// "Am pierdut cartea de muncă" cannot be combined with the other options
const normalizeTipAdeverinta = (value = [], prevValue = []) => {
    if (value.includes(lostWorkBook) && !prevValue.includes(lostWorkBook)) {
        return [lostWorkBook];
    }

    if (value.includes(lostWorkBook) && value.length > 1) {
        return value.filter((item) => item !== lostWorkBook);
    }

    return value;
};

const Step2 = ({ disabled }) => {
    const options = [
        { label: 'ANEXA Nr. 6 | Lege 360/2023 privind sistemul public de pensii', value: '1' },
        { label: 'Grupă muncă', value: '2' },
        {
            label: 'Adeverință de vechime',
            value: '3',
            tooltip:
                'Adeverința de vechime se poate solicita numai în situația în care carnetul / cartea de muncă a fost declarată pierdută în Monitorul Oficial. În acest caz, solicitantul va încărca declarația și/sau dovada publicării în Monitorul Oficial.'
        },
        {
            label: 'Am pierdut cartea de muncă',
            value: lostWorkBook,
            tooltip:
                'DACIA va comunica seria și numărul cărții de muncă, iar solicitantul va declara pierderea acesteia în Monitorul Oficial. Comunicarea va fi transmisă pe adresa de e-mail a solicitantului.'
        }
    ];

    return (
        <div className={styles.wrapper} id='step_2'>
            <h2>Pasul 2. Selectarea adeverințelor solicitate</h2>
            <p>Specificați tipul de adeverințe solicitate.</p>

            <Form.Item
                name={['step2', 'tip_adeverinta']}
                label='Solicit eliberarea adeverințelor privind:'
                rules={[FORM_RULES.requiredStep2]}
                normalize={normalizeTipAdeverinta}
            >
                <Checkbox.Group disabled={disabled}>
                    <Space direction='vertical'>
                        {options.map((option, index) => (
                            <Checkbox value={option.value} key={index}>
                                {option.label}
                                {option.tooltip ? (
                                    <Tooltip title={option.tooltip} trigger={['hover', 'click']}>
                                        <InfoCircleFilled
                                            className={styles.info}
                                            onClick={(e) => e.preventDefault()}
                                        />
                                    </Tooltip>
                                ) : null}
                            </Checkbox>
                        ))}
                    </Space>
                </Checkbox.Group>
            </Form.Item>
        </div>
    );
};

export default Step2;
